// 映恩生物-B
import Overview from './overview.vue';

export const componentMap = {
	overview: Overview
};
